export default __webpack_public_path__ + "static/media/calendar25.13cfd120.svg";